import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=94d80780&scoped=true"
import script from "./ResetForm.vue?vue&type=script&lang=js"
export * from "./ResetForm.vue?vue&type=script&lang=js"
import style0 from "./ResetForm.vue?vue&type=style&index=0&id=94d80780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d80780",
  null
  
)

export default component.exports